export const passwordValidate = (password: string) => {
  const passwordRegExp =
    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+[\]{};':"\\|,.<>/?]).{8,}$/;

  if (passwordRegExp.test(password) === false) return false;
  return true;
};
